import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip } from 'recharts';
import { LiaClipboardListSolid } from "react-icons/lia";
import { useState } from 'react';
import ReportDescriptionModal from './ReportDescriptionModal';

const WaitingByStatusChart = ({report}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Simple tooltip
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="bg-gray-800 text-white px-3 py-2 rounded">
          <p className="text-sm">{data.name}</p>
          <p className="text-sm">{data.value.toLocaleString()} alunos</p>
        </div>
      );
    }
    return null;
  };

  const data = report?.lines?.map(line => ({
    name: line.key,
    value: parseInt(line.value)
  })) || [];

  return (
    <>
      <div className='flex items-center gap-2 mb-4'>
        <LiaClipboardListSolid className="text-xl text-purple-600" />
        <h3 className='text-lg font-semibold text-gray-900'>{report?.title || 'Status das Rematrículas'}</h3>
        {report?.description && (
          <button
            onClick={() => setIsModalOpen(true)}
            className="w-4 h-4 bg-gray-400 rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-500 transition-colors duration-200"
          >
            <span className="text-white text-xs font-bold">?</span>
          </button>
        )}
      </div>
      
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 20, right: 30, left: 5, bottom: 5 }}>
            <XAxis 
              dataKey="name" 
              tick={{ fontSize: 11 }}
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis tick={{ fontSize: 12 }} />
            <Tooltip content={<CustomTooltip />} />
            <Bar dataKey="value" fill="#3B82F6" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      
      <ReportDescriptionModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={report?.title || 'Status das Rematrículas'}
        description={report?.description}
      />
    </>
  );
};

export default WaitingByStatusChart;